import React, { useEffect, useState } from "react";
import "./herosection.css"; // Updated CSS file name
import handshake from "../assets/images/handshake.jpg"; 

const NewHeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("new-hero-section");
      if (section.getBoundingClientRect().top < window.innerHeight * 0.75) {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="new-hero-section" id="new-hero-section">
      <div className={`new-container ${isVisible ? "new-show" : ""}`}>
        {/* Left Side - Image */}
        <div className="new-hero-image new-fade-in-left">
          <img src={handshake} alt="Lawyer" />
        </div>

        {/* Right Side - Content */}
        <div className="new-hero-content new-fade-in-right">
          <div className="new-highlight">
            <span className="new-icon">⚖️</span> People make the difference
          </div>
          <h1>
            We are here to provide <span>legal consultancy</span>
          </h1>
          <p>
            All people are equal before the law. A good attorney is what makes
            the difference. We specialize in corporate, business, and property
            law, ensuring justice and legal security.
          </p>
          <div className="new-signature">
            <p className="new-name">Adv. Sujata Patekar</p>
            <span>Founder & Legal Consultant</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewHeroSection;
